import React from 'react';
import { Indicator, Tooltip, UnstyledButton } from '@mantine/core';
import { useFeatureTips } from './FeatureTipsProvider';

function formatBadgeLabel(count: number): string {
  if (count > 99) return '99+';
  return String(count);
}

/** Header entry for Tips / What’s new. Always available. */
export function FeatureTipsHeaderButton() {
  const { undismissedCount, openTipsHub } = useFeatureTips();
  const showBadge = undismissedCount > 0;
  const tooltipLabel = showBadge
    ? `Tips (${undismissedCount} new)`
    : 'Tips';

  return (
    <Tooltip label={tooltipLabel} withArrow>
      <Indicator
        label={formatBadgeLabel(undismissedCount)}
        size={16}
        color="brand"
        offset={4}
        disabled={!showBadge}
      >
        <UnstyledButton
          className="app-header-help-btn"
          aria-label={tooltipLabel}
          onClick={() => openTipsHub()}
        >
          Tips
        </UnstyledButton>
      </Indicator>
    </Tooltip>
  );
}
